import React from 'react';
import InputGroups from '../../../Componant/Forms/FormControl/InputGroups';

const InputGroupsForm = () => {
  return (
    <div className='page-body'>
      <InputGroups />
    </div>
  );
};

export default InputGroupsForm;
